import { Paper, Typography } from "@mui/material"
import { DragIndicator } from '@mui/icons-material';
import FlexBetween from 'components/FlexBetween';


const MetricCard = ({ 
    title = '', 
    subtitle = '', 
    value, 
    icon = <DragIndicator sx={{ color: "green.dark", fontSize: 24 }} />,
    bgColor = "primary.lightest",
}) => {

    return (
        <Paper
            sx={{
                position: "relative",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                px: 1.5,
                py: 0.5,
                borderRadius: 1,
                border: "1px solid",
                borderColor: "neutral.deep",
                backgroundColor: bgColor,
            }}
            elevation={0}
        >
            <FlexBetween>
                <Typography 
                    variant="body1" 
                    sx={{ color: "text.primary" }}
                >
                    {title}
                </Typography>
                <FlexBetween>{icon}</FlexBetween>
            </FlexBetween>

            <Typography variant="h5" pl={1}>
                {value}
            </Typography>

            <Typography variant="h6" sx={{ color: "text.secondary" }}>
                {subtitle}
            </Typography>
        </Paper>
    )
}

export default MetricCard
